import { useQueryClient, type MutationFunction } from "@tanstack/react-query";
import type { Money } from "@/lib/domain/Money";
import { paginatedPrepend, useHTTP, useHTTPMutation, type HTTPResponse } from "@/lib/http";
import type { PriceOverrideDetailsResponseModel } from "@/features/priceOverrides/api/usePriceOverrideDetails";
import { clearCacheAfterPriceOverrideMutation } from "@/features/priceOverrides/api/clearCacheAfterPriceOverrideMutation";

export interface PriceOverrideCreateRequestModel {
	readonly variantId: string;
	readonly price: Money;
}

export const usePriceOverrideCreate = () => {
	const http = useHTTP("Required");
	const queryClient = useQueryClient();

	const mutationFn: MutationFunction<HTTPResponse<PriceOverrideDetailsResponseModel>, PriceOverrideCreateRequestModel> = requestModel => {
		return http<PriceOverrideDetailsResponseModel, PriceOverrideCreateRequestModel>({
			method: "POST",
			url: "/price-override",
			body: requestModel
		});
	};

	return useHTTPMutation({
		mutationFn,
		onSuccess: (data) => {
			queryClient.setQueryData(["priceOverrideDetails"], paginatedPrepend(data.body));
			clearCacheAfterPriceOverrideMutation(queryClient);
		}
	});
};
